import { makeStyles } from '@material-ui/core'

import { getFont } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '173px repeat(6,1fr)',
    position: 'relative',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '133px',
      gridTemplateColumns: '1fr'
    }
  },
  titleContainer: {
    height: 50,
    textAlign: 'center',
    fontWeight: 700,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    color: theme.palette.primary.main,
    fontFamily: getFont()
  },
  valueContainer: {
    height: 50,
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  restrictionSelector: {
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[100]}`
  },
  restrictionSelectorTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  inventoryRestrictionSelectorContainer: {
    position: 'absolute',
    top: 110,
    left: 0,
    zIndex: 1
  }
}))

export default useStyles
